import cn from '@sindresorhus/class-names';
import Link from 'next/link';

import {Chevron} from '../assets/Icons/Chevron';
import styles from './BreadcrumbsItem.module.scss';
import {BreadcrumbsItemProps} from './types';

export const BreadcrumbsItem = ({
  item: {path, title},
  displayMode,
  position,
  onItemClick,
}: BreadcrumbsItemProps) => {
  return (
    <li
      itemProp="itemListElement"
      itemScope
      itemType="https://schema.org/ListItem"
      className={styles.listItem}
    >
      <Link
        href={path}
        className={cn(
          styles.link,
          displayMode === 'current_page' && styles.disabled,
        )}
        onClick={() => onItemClick?.(title, position)}
        itemProp="item"
        aria-current={displayMode === 'current_page' ? 'page' : undefined}
        prefetch={false}
        data-testid={`breadcrumbs-${position}`}
      >
        <span itemProp="name" className={styles.linkText}>
          {title}
        </span>

        <meta itemProp="position" content={`${position}`} />
      </Link>

      {displayMode === 'link_with_chevron' && (
        <Chevron className={styles.chevron} aria-hidden={true} />
      )}
    </li>
  );
};
